<a [routerLink]="back ? '../' : '/home'" [title]="'GO_BACK' | translate" class="btn btn-primary text-white rounded-circle position-fixed p-2">
  <svg-icon class="d-flex" [src]="'assets/img/icons/mat-arrow-back.svg'" [svgStyle]="{ 'fill': 'currentColor', 'width': '21px', 'height': '21px' }"></svg-icon>
</a>
